
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 1.333V0h12v12h-1.333V1.333H4z"}}),_c('path',{attrs:{"d":"M10.61 6.943L5.47 12.08 2.667 9.276l.942-.943 1.862 1.862L9.667 6l.943.943z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 2.667V16h13.333V2.667H0zM12 4H1.333v10.667H12V4z"}})])
          )
        }
      }
    